import React from "react";
import "../style.css";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Field, reduxForm } from "redux-form";
import { ToastContainer } from "react-toastify";
import { compose } from "redux";
import RenderDatePicker from "../../Utility/RenderDatePicker";

const DownloadModal = ({ open, setOpen, handleSubmit, onDownloadReport }) => {
  const validate = (values) => {
    const errors = {};
    let frDate = new Date(values.fromDate).getTime();
    let tDate = new Date(values.toDate).getTime();
    const requiredFields = ["fromDate", "toDate"];
    requiredFields.forEach((field) => {
      if (!values[field]) {
        errors[field] = "Required";
      }
    });
    if (frDate > tDate) {
      errors["fromDate"] = "From date cannot be later than To Date";
    }
    if (frDate + 604800000 < tDate) {
      errors["toDate"] = "Maximum allowed period is 7 days";
    }
    return errors;
  };
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={open}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"Select Period"}</Typography>
          <CloseIcon
            onClick={() => setOpen(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        <div style={{ marginTop: "5%" }}>
          <form onSubmit={handleSubmit(onDownloadReport)}>
            <div className="container">
              <div className="d-flex justify-content-space-between">
                <div className="col-sm-6">
                  <Field
                    name="fromDate"
                    label="From Date"
                    type="date"
                    style={{
                      paddingTop: "6%",
                      paddingBottom: "12%",
                      fontFamily: "GT-Walsheim-medium",
                      fontSize: "14px",
                    }}
                    component={RenderDatePicker}
                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="toDate"
                    label="To Date"
                    type="date"
                    style={{
                      paddingTop: "6%",
                      paddingBottom: "12%",
                      fontFamily: "GT-Walsheim-medium",
                      fontSize: "14px",
                    }}
                    component={RenderDatePicker}
                  />
                </div>
              </div>
              <div className="card-deck row">
                <div
                  className="col-sm-12"
                  style={{ textAlign: "center", marginTop: "25%" }}
                >
                  <Button
                    type="submit"
                    variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                textTransform: "capitalize",
              }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </form>
          <ToastContainer />
        </div>
      </MuiDialogContent>
    </Dialog>
  );
};

export default compose(
  reduxForm({
    form: "DownloadModal",
    // validate,
  })
)(DownloadModal);
